export default __webpack_public_path__ + "static/media/home-yoga-meditation-facility-img02.ded69ee1.jpg";